let redirecting = false;

/** Navigate to the photo-auth app, preserving the query string.
 *
 * Assigning `window.location.href` does not stop script execution, so callers
 * still running setup code must check `isRedirectingToPhotoAuth()` before
 * initializing the scanner.
 */
function redirectToPhotoAuth() {
  redirecting = true;
  window.location.href = `${window.location.origin}/${import.meta.env.VITE_PHOTO_AUTH_PREFIX}${window.location.search}`;
}

function isRedirectingToPhotoAuth() {
  return redirecting;
}

export { redirectToPhotoAuth, isRedirectingToPhotoAuth };
